import { DISCOVERY_PATH_PREFIX } from './discoveryPaths';

export const INDEX_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export const INDEX_LETTERS = ['#', ...INDEX_ALPHABET];

/** URL segment for a browse letter (`#` → `0-9`). */
export const letterToParam = letter => {
  const value = String(letter || '').trim().toUpperCase();
  return value === '#' ? '0-9' : value.toLowerCase();
};

/** Browse letter from a route param (`0-9` → `#`). */
export const letterFromParam = param => {
  const value = String(param || '').trim().toLowerCase();
  if (value === '0-9' || value === 'numbers') {
    return '#';
  }
  const upper = value.toUpperCase();
  return /^[A-Z]$/.test(upper) ? upper : null;
};

export const parseIndexPageParam = page => {
  const n = parseInt(String(page || '1'), 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
};

export const venuesLetterPath = (letter, page = 1) => {
  const param = letterToParam(letter);
  const base = `${DISCOVERY_PATH_PREFIX}/venues/letter/${param}`;
  return page > 1 ? `${base}/${page}/` : `${base}/`;
};

export const citiesLetterPath = (letter, page = 1) => {
  const param = letterToParam(letter);
  const base = `${DISCOVERY_PATH_PREFIX}/cities/letter/${param}`;
  return page > 1 ? `${base}/${page}/` : `${base}/`;
};

export const performersLetterPath = (letter, page = 1) => {
  const param = letterToParam(letter);
  const base = `${DISCOVERY_PATH_PREFIX}/performers/letter/${param}`;
  return page > 1 ? `${base}/${page}/` : `${base}/`;
};

export const venuesIndexPath = () => `${DISCOVERY_PATH_PREFIX}/venues/`;

export const citiesIndexPath = () => `${DISCOVERY_PATH_PREFIX}/cities/`;

export const performersIndexPath = () => `${DISCOVERY_PATH_PREFIX}/performers/`;

export const VENUE_INDEX_PAGE_SIZE = 250;
export const CITY_INDEX_PAGE_SIZE = 250;
export const PERFORMER_INDEX_PAGE_SIZE = 250;
